export const policiesInitialState = [
  {
    id: 'POL-2024-001',
    policyNumber: 'BIM-2024-001',
    clientName: 'Acme Corporation',
    clientAvatar: null,
    type: 'Commercial Property',
    status: 'active',
    premium: 2500000,
    coverage: 50000000,
    startDate: '2024-01-15',
    endDate: '2025-01-14',
    renewalDays: 65,
    agent: 'John Doe',
    risk: 'low',
  },
  {
    id: 'POL-2024-002',
    policyNumber: 'BIM-2024-002',
    clientName: 'Tech Solutions Ltd',
    clientAvatar: null,
    type: 'Professional Liability',
    status: 'active',
    premium: 1800000,
    coverage: 30000000,
    startDate: '2024-02-01',
    endDate: '2025-01-31',
    renewalDays: 82,
    agent: 'Sarah Smith',
    risk: 'medium',
  },
  {
    id: 'POL-2024-003',
    policyNumber: 'BIM-2024-003',
    clientName: 'Global Traders Inc',
    clientAvatar: null,
    type: 'Marine Cargo',
    status: 'pending',
    premium: 3200000,
    coverage: 75000000,
    startDate: '2024-03-10',
    endDate: '2025-03-09',
    renewalDays: 119,
    agent: 'Michael Brown',
    risk: 'high',
  },
  {
    id: 'POL-2024-004',
    policyNumber: 'BIM-2024-004',
    clientName: 'Healthcare Plus',
    clientAvatar: null,
    type: 'Medical Malpractice',
    status: 'active',
    premium: 4500000,
    coverage: 100000000,
    startDate: '2024-01-20',
    endDate: '2025-01-19',
    renewalDays: 70,
    agent: 'John Doe',
    risk: 'medium',
  },
  {
    id: 'POL-2024-005',
    policyNumber: 'BIM-2024-005',
    clientName: 'Construction Co',
    clientAvatar: null,
    type: 'Contractors All Risk',
    status: 'expired',
    premium: 5000000,
    coverage: 120000000,
    startDate: '2023-06-01',
    endDate: '2024-05-31',
    renewalDays: -164,
    agent: 'Sarah Smith',
    risk: 'high',
  },
  {
    id: 'POL-2024-006',
    policyNumber: 'BIM-2024-006',
    clientName: 'Retail Masters',
    clientAvatar: null,
    type: 'Business Interruption',
    status: 'active',
    premium: 1500000,
    coverage: 25000000,
    startDate: '2024-04-01',
    endDate: '2025-03-31',
    renewalDays: 141,
    agent: 'Michael Brown',
    risk: 'low',
  },
  {
    id: 'POL-2024-007',
    policyNumber: 'BIM-2024-007',
    clientName: 'Transport Logistics',
    clientAvatar: null,
    type: 'Motor Fleet',
    status: 'active',
    premium: 3800000,
    coverage: 80000000,
    startDate: '2024-02-15',
    endDate: '2025-02-14',
    renewalDays: 96,
    agent: 'John Doe',
    risk: 'medium',
  },
  {
    id: 'POL-2024-008',
    policyNumber: 'BIM-2024-008',
    clientName: 'Manufacturing Industries',
    clientAvatar: null,
    type: 'Product Liability',
    status: 'pending',
    premium: 2800000,
    coverage: 60000000,
    startDate: '2024-05-01',
    endDate: '2025-04-30',
    renewalDays: 171,
    agent: 'Sarah Smith',
    risk: 'high',
  },
];
